import type {
    ClearCommerceCartRequest,
    ClearCommerceCartResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const clearCommerceCartOperation = defineCommerceOperation<
    ClearCommerceCartRequest,
    ClearCommerceCartResponse
>("commerce.cart.clear");
